// 現在開いているモーダル数（背面スクロール抑止の制御用）
let __openModalCount = 0;

// スクロール位置・スタイル退避用（背景が先頭に戻らないように固定）
let __lockedScrollY = 0;
let __htmlOverflowBeforeLock = "";
let __bodyOverflowBeforeLock = "";
let __bodyPositionBeforeLock = "";
let __bodyTopBeforeLock = "";
let __bodyWidthBeforeLock = "";
let __bodyPaddingRightBeforeLock = "";
let __htmlScrollBehaviorBeforeLock = "";

const getScrollbarWidth = () => {
  return window.innerWidth - document.documentElement.clientWidth;
};

// 背面スクロール抑止（スクロール位置保持版）
const lockScroll = () => {
  __lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;

  // 既存のインラインスタイルを退避
  __htmlOverflowBeforeLock = document.documentElement.style.overflow;
  __htmlScrollBehaviorBeforeLock =
    document.documentElement.style.scrollBehavior;
  __bodyOverflowBeforeLock = document.body.style.overflow;
  __bodyPositionBeforeLock = document.body.style.position;
  __bodyTopBeforeLock = document.body.style.top;
  __bodyWidthBeforeLock = document.body.style.width;
  __bodyPaddingRightBeforeLock = document.body.style.paddingRight;

  // スクロールバー分のレイアウトシフトを防ぐ
  const sw = getScrollbarWidth();
  if (sw > 0) {
    document.body.style.paddingRight = `${sw}px`;
  }

  // 実際のロック
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.top = `-${__lockedScrollY}px`;
  document.body.style.width = "100%";
};

const unlockScroll = () => {
  // 復帰スクロールを即時にするため、一時的に scroll-behavior を auto に
  const docEl = document.documentElement;
  docEl.style.scrollBehavior = "auto";

  // 先にスタイルを元へ戻す
  document.documentElement.style.overflow = __htmlOverflowBeforeLock;
  document.body.style.overflow = __bodyOverflowBeforeLock;
  document.body.style.position = __bodyPositionBeforeLock;
  document.body.style.top = __bodyTopBeforeLock;
  document.body.style.width = __bodyWidthBeforeLock;
  document.body.style.paddingRight = __bodyPaddingRightBeforeLock;

  // その後に元のスクロール位置へ復帰
  if (typeof __lockedScrollY === "number" && !Number.isNaN(__lockedScrollY)) {
    window.scrollTo(0, __lockedScrollY);
  }

  // 次フレームで scroll-behavior を元に戻す（外部CSSの smooth を再適用させる）
  requestAnimationFrame(() => {
    docEl.style.scrollBehavior = __htmlScrollBehaviorBeforeLock;
  });
};

const isVisible = (el) => {
  if (!el) return false;
  const cs = window.getComputedStyle(el);
  return cs.display !== "none" && cs.visibility !== "hidden";
};

// モーダルを開く
function openModalById(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    // 表示状態にする
    const wasVisible = isVisible(modal);
    if (!wasVisible) {
      __openModalCount += 1;
      if (__openModalCount === 1) lockScroll();
    }
    modal.style.display = "block";
    // 閉じ処理中フラグを解除
    if (modal.dataset) delete modal.dataset.closing;
    // CSSでデフォルトopacity:0が指定されているため、可視化も行う
    // リフロー後に反映しておくとトランジションを付けた際にも自然
    requestAnimationFrame(() => {
      modal.style.opacity = "1";
    });
  }
}

// モーダルを閉じる
function closeModalById(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    // すでに閉じ処理中なら二重に動かさない
    if (modal.dataset && modal.dataset.closing === "1") return;
    if (modal.dataset) modal.dataset.closing = "1";
    // フェードアウト: 先にopacityを0にし、トランジション終了後にdisplay:none
    const onFadeOutEnd = (e) => {
      if (e.propertyName === "opacity") {
        modal.style.display = "none";
        modal.removeEventListener("transitionend", onFadeOutEnd);
        if (modal.dataset) delete modal.dataset.closing;
        // カウントを減らして、0ならスクロールロック解除
        __openModalCount = Math.max(0, __openModalCount - 1);
        if (__openModalCount === 0) unlockScroll();
      }
    };
    modal.addEventListener("transitionend", onFadeOutEnd);
    // トランジションが効くように、リフロー後にopacityを変更
    requestAnimationFrame(() => {
      modal.style.opacity = "0";
    });
  }
}

// data属性でモーダルを開く処理
document.querySelectorAll("[data-modal-target]").forEach((el) => {
  el.addEventListener("click", () => {
    const targetId = el.getAttribute("data-modal-target");
    openModalById(targetId);
  });
});

// data属性でモーダルを閉じる処理
document.querySelectorAll("[data-modal-close]").forEach((el) => {
  el.addEventListener("click", () => {
    const modal = el.closest(".modal");
    if (modal) {
      closeModalById(modal.id);
    }
  });
});

// Escキーで可視のモーダルを閉じる（最後に開いているものを優先）
document.addEventListener("keydown", (e) => {
  const key = e.key || e.code;
  if (key === "Escape" || key === "Esc" || e.keyCode === 27) {
    const modals = Array.from(document.querySelectorAll(".modal"));
    // DOM順の最後（前面想定）から探す
    for (let i = modals.length - 1; i >= 0; i--) {
      const m = modals[i];
      if (isVisible(m)) {
        closeModalById(m.id);
        break;
      }
    }
  }
});
